export const contactsData = {
  email: 'luisrangelc@gmail.com',
  phone: '+50256917111',
  address: 'Tecpán Guatemala, Chimaltenango, Guatemala - 04006',
  sheetAPI: '',
};
